import { sortBy } from 'lodash';
import { useMemo } from 'react';
import meetingState from '../../../data/constants/meetingState';
import { useEventSchedule } from '../../../data/hooks/schedule/useEventSchedule';
import useScheduleMeetings from './useScheduleMeetings/useScheduleMeetings';

/**
 * Returns the visible schedule and meetings merged
 *
 * @param {number} eventId Event ID
 * @param {function} scheduleFilter Schedule filter
 * @param {function} meetingsFilter Meetings filter
 * @param {function} commonFilter Common filter
 * @param {function} sortFunction Sort function
 *
 * @returns [schedule+items]
 */
export function useScheduleAndMeetings(eventId, { scheduleFilter, meetingsFilter, filter: commonFilter, sortBy: sortFunction } = {}) {
    const schedule = useEventSchedule(eventId, {
            filter: scheduleFilter,
        }),
        meetings = useScheduleMeetings(eventId, { filter: meetingsFilter });

    return useMemo(() => {
        let result = [
            ...schedule,
            ...meetings
                .filter((meeting) => meeting._state == meetingState.CONFIRMED)
                .map((m) => ({
                    ...m,
                    _isMeeting: true,
                })),
        ];

        if (commonFilter) result = result.filter(commonFilter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [schedule, meetings, commonFilter, sortFunction]);
}
